import httpClient from "Api/httpClient";

const END_POINT = "/scrap_authorization";

const getScrapAuthorizations = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getScrapAuthorization = (scrap_auth_id) => {
    if (!scrap_auth_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + scrap_auth_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printScrapAuthorization = (scrap_auth_id) => {
    if (!scrap_auth_id) return;
    const SINGLE_END_POINT = END_POINT + "/print/" + scrap_auth_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createScrapAuthorizations = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateScrapAuthorizations = (payload, scrap_auth_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + scrap_auth_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteScrapAuthorizations = (scrap_auth_id) => {
    const DELETE_END_POINT = END_POINT + "/" + scrap_auth_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export {
    getScrapAuthorizations,
    getScrapAuthorization,
    printScrapAuthorization,
    createScrapAuthorizations,
    updateScrapAuthorizations,
    deleteScrapAuthorizations,
};
